<template>
  <v-card>
    <v-text-field
      v-model="newCategoryTitle"
      :label="$t('Documents.Button.newCategory')"
      type="text"
      class="px-4"
      @keyup.enter="addCategory"
    >
      <template v-slot:append class="ma-0 pa-0">
        <v-btn icon @click="addCategory" :disabled="!newCategoryTitle">
          <v-icon color="primary">add_box</v-icon>
        </v-btn>
      </template>
    </v-text-field>
    <v-list>
      <template v-for="(category, index) in categories">
        <v-list-item :key="'category' + category.id">
          <v-list-item-action>
            <v-icon>mdi-file-table-box</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <span v-if="editing.index !== index" @dblclick="edit(index)">{{ category.title }}</span>
            <v-text-field v-else v-model="category.title" hide-details single-line filled>
              <template v-slot:append v-if="editing.index === index">
                <v-btn icon @click="reset">
                  <v-icon>cancel</v-icon>
                </v-btn>
                <v-btn icon @click="save">
                  <v-icon>save</v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-list-item-content>
          <template v-if="editing.index !== index">
            <v-list-item-action>
              <v-switch color="primary" v-model="category.isVisible" @click.stop="updateCategory(category)"></v-switch>
            </v-list-item-action>
            <v-list-item-action>
              <v-btn icon @click.stop="deleteCategory(category.id)">
                <v-icon>delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </template>
        </v-list-item>
        <v-divider v-if="(index + 1) < categories.length" :key="'divider' + category.id"></v-divider>
      </template>
    </v-list>
  </v-card>
</template>

<script>
import CategoryService from '@/services/categories'
export default {
  name: 'DocumentCategories',
  data: () => ({
    categories: [],
    newCategoryTitle: '',
    editing: {
      index: null,
      cache: null
    }
  }),
  computed: {
    defaultCategory () {
      return {
        title: '',
        isVisible: false,
        orderNb: this.categories.length + 1
      }
    }
  },
  methods: {
    async loadCategories () {
      this.categories = await CategoryService.getAll()
    },
    async addCategory () {
      try {
        const newCategory = await CategoryService.create({...this.defaultCategory, title: this.newCategoryTitle})
        this.categories.push(newCategory)
        this.newCategoryTitle = ''
      } catch (error) {
        this.$store.dispatch('errorMessage', this.$t('Message.Error.create'))
      }
    },
    async updateCategory (category) {
      try {
        const updatedCategory = await CategoryService.update({...category})
        this.categories.splice(this.categories.findIndex(cat => cat.id === category.id), 1, updatedCategory)
      } catch (error) {
        this.$store.dispatch('errorMessage', this.$t('Message.Error.update'))
      }
    },
    async deleteCategory (id) {
      try {
        if (confirm(this.$t('Documents.Message.deleteCategory'))) {
          await CategoryService.delete(id)
          this.categories.splice(this.categories.findIndex(cat => cat.id === id), 1)
        }
      } catch (error) {
        this.$store.dispatch('errorMessage', this.$t('Message.Error.delete'))
      }
    },
    edit (index) {
      if (this.editing.index !== null) this.reset()
      this.editing = {
        index,
        cache: this.categories[index].title
      }
    },
    reset (useCache = false) {
      if (useCache) this.categories[this.editing.index].title = this.editing.cache
      this.editing = {
        index: null,
        cache: null
      }
    },
    async save () {
      await this.updateCategory(this.categories[this.editing.index])
      this.reset()
    }
  },
  created () {
    this.loadCategories()
  }
}
</script>